import { render, staticRenderFns } from "./ClearButton.vue?vue&type=template&id=5661f470&"
import script from "./ClearButton.vue?vue&type=script&lang=ts&"
export * from "./ClearButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports